import React from "react";
import styles from '../../styles/countryadmissionsday.module.scss';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import CustomImage from "../CustomImage";
interface Props {
    benefitdata: any;
}

const BenefitsOfAttendaAdmissionDay: React.FC<Props> = ({ benefitdata }) => {
    return (
        <>
            <div id="benefits-attend" className={styles.benefitsAttend} style={{ backgroundColor: benefitdata?.sectionBgColor || "#fff" }}>
                <Container>
                    <div className={styles.maindiv}>
                        <Row>
                            <div className={styles.heading}>
                                <h2>{benefitdata?.sectionTitle}</h2>
                            </div>
                        </Row>
                        <Row>
                            {
                                benefitdata?.pointImage?.length > 0 &&
                                benefitdata?.pointImage?.map((pointImages: any) => {
                                    return (
                                        <Col xl={6} lg={6} md={6} sm={12} xs={6}>
                                            <div className={styles.mainBox}>
                                                <div className={styles.box}>
                                                    <div className={styles.img}>
                                                        <CustomImage src={pointImages?.imageUrl} width={30} height={30} className={styles.studImg} alt="handshake.png" />
                                                    </div>
                                                    <div className={styles.para}>
                                                        <p>{pointImages?.title}</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </Col>
                                    )
                                })
                            }
                        </Row>
                    </div>
                </Container>
            </div>
        </>
    )
}
export default BenefitsOfAttendaAdmissionDay;